import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_PUBLIC_KEY } from "@config/constants";
import PropTypes from "prop-types";

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const appearance = {
	theme: "stripe",
	variables: {
		colorPrimary: "#FF7800",
	},
};

export const StripeProvider = ({ children }) => (
	<Elements
		stripe={stripePromise}
		options={{
			mode: "payment",
			currency: "aud",
			amount: 1000, // Amount in cents (e.g., $10.00)
			appearance,
			payment_method_types: ["card"],
		}}>
		{children}
	</Elements>
);

StripeProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default StripeProvider;